import { useTheme, getColorVisionEventAttrs, getColorVisionStylesForActiveIndex } from '@shopify/polaris-viz-core';
import { useRef, useState, useEffect } from 'react';
import { LEGEND_ITEM_LEFT_PADDING, LEGEND_ITEM_RIGHT_PADDING, LEGEND_ITEM_GAP } from '../../constants.js';
import { PREVIEW_ICON_SIZE } from '../../../../constants.js';
import style from './LegendItem.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SeriesIcon } from '../../../shared/SeriesIcon/SeriesIcon.js';

const MINIMUM_LEGEND_ITEM_WIDTH = 100;
const MINIMUM_LEGEND_ITEM_WITH_VALUE_WIDTH = 200;
function LegendItem({
  activeIndex = -1,
  color,
  colorVisionType,
  index,
  isComparison,
  name,
  renderSeriesIcon,
  shape,
  theme,
  value,
  onDimensionChange,
  backgroundColor,
  truncate = false,
  showLegendValues = false
}) {
  const selectedTheme = useTheme(theme);
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  const minWidth = value != null ? MINIMUM_LEGEND_ITEM_WITH_VALUE_WIDTH : MINIMUM_LEGEND_ITEM_WIDTH;
  useEffect(() => {
    if (onDimensionChange && ref.current != null) {
      const {
        width,
        height
      } = ref.current.getBoundingClientRect();
      setWidth(width);
      onDimensionChange({
        width: Math.min(minWidth, Math.round(width)),
        height
      });
    }
  }, [onDimensionChange, ref, minWidth]);
  const colorBlindAttrs = colorVisionType == null ? {} : getColorVisionEventAttrs({
    type: colorVisionType,
    index
  });
  const background = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : selectedTheme.legend.backgroundColor;
  return /*#__PURE__*/jsxs("button", { ...colorBlindAttrs,
    style: {
      background,
      ...getColorVisionStylesForActiveIndex({
        activeIndex,
        index
      }),
      paddingLeft: LEGEND_ITEM_LEFT_PADDING,
      paddingRight: LEGEND_ITEM_RIGHT_PADDING,
      gap: LEGEND_ITEM_GAP,
      // if there is overflow, add a max width and truncate with ellipsis
      maxWidth: truncate ? minWidth : undefined,
      // if the item width is less than the minWidth, don't set a min width
      minWidth: width < minWidth ? undefined : minWidth
    },
    className: style.Legend,
    ref: ref,
    children: [renderSeriesIcon == null ? /*#__PURE__*/jsx("span", {
      style: {
        height: PREVIEW_ICON_SIZE,
        width: PREVIEW_ICON_SIZE
      },
      className: style.IconContainer,
      children: /*#__PURE__*/jsx(SeriesIcon, {
        shape: shape,
        color: color,
        isComparison: isComparison
      })
    }) : renderSeriesIcon(), /*#__PURE__*/jsxs("span", {
      className: style.TextContainer,
      children: [/*#__PURE__*/jsx("span", {
        className: style.Text,
        style: {
          color: selectedTheme.legend.labelColor
        },
        children: name
      }), !showLegendValues || value == null ? null : /*#__PURE__*/jsx("span", {
        className: style.Text,
        style: {
          color: selectedTheme.legend.valueColor
        },
        children: value
      })]
    })]
  });
}

export { LegendItem, MINIMUM_LEGEND_ITEM_WIDTH, MINIMUM_LEGEND_ITEM_WITH_VALUE_WIDTH };
